export const getHeaderBannerStickyHeight = () => {
	const STICKY_HEIGHT = parseInt(
		process.env
			.REACT_APP_HEADER_STICKY_HEIGHT_PX || '21.5'
	)
	return STICKY_HEIGHT
}
